function setProgressHeight() {
  var progressBar = document.querySelector('.oystex-grid-progress');
  var processBlock = document.querySelector('.oystex-phase-grid');
  if (processBlock === null || progressBar === null) return;

  progressBar.style.height = processBlock.scrollHeight + 'px';
}

function asyncScript(u, c) {
  var d = document, t = 'script',
    o = d.createElement(t),
    s = d.getElementsByTagName(t)[0];
  o.src = '//' + u;
  if (c) {o.addEventListener('load', function (e) {c(null, e);}, false);}
  s.parentNode.insertBefore(o, s);
}

function loadScript(src, callback = false) {
  var s,
    r,
    t;
  r = false;
  s = document.createElement('script');
  s.type = 'text/javascript';
  s.src = src;
  s.onload = s.onreadystatechange = function () {
    //console.log( this.readyState ); //uncomment this line to see which ready states are called.
    if (!r && (!this.readyState || this.readyState == 'complete') && callback) {
      r = true;
      callback();
    }
  };
  t = document.getElementsByTagName('script')[0];
  t.parentNode.insertBefore(s, t);
}

function runScrolls() {
  // Process row scroll/fade-ins
  var rows = document.querySelectorAll('.phase-grid-item');
  var i = 0;
  console.log(rows);
  gsap.utils.toArray(rows).forEach(function (row) {
    gsap.fromTo(row.children[0],
      {
        autoAlpha: 0,
        y: 80,
        x: row.classList.contains('flex--reverse') ? 150 : -150
      },
      {
        scrollTrigger: {
          trigger: row,
          scrub: 1,
          start: "top bottom",
          end: "+=250",
          onLeaveBack: function (self) {
            self.disable();
            row.children[0].style.opacity = 1;
            row.children[0].style.transform = 'unset';
          }
        },
        // stagger: 0.25,
        autoAlpha: 1,
        y: 0,
        x: 0
      });

    gsap.fromTo(row.children[1],
      {
        autoAlpha: 0,
        y: 80
      },
      {
        scrollTrigger: {
          trigger: row,
          scrub: 1,
          start: "top bottom",
          end: "+=250",
          onLeaveBack: function (self) {
            self.disable();
            row.children[1].style.opacity = 1;
            row.children[1].style.transform = 'unset';
          }
        },
        // stagger: 0.25,
        autoAlpha: 1,
        y: 0
      });
  });

  // Progress Bar Scroll
  var progressBar = document.querySelector('.oystex-grid-progress');
  var processGrid = document.querySelector('.oystex-phase-grid');
  if (processGrid !== null && progressBar !== null) {
    ScrollTrigger.create({
      trigger: processGrid,
      start: "top 16.5%",
      end: "bottom bottom",
      pin: progressBar
    });
    // Move the beacon
    var beacon = document.getElementById('the-beacon-of-progress');
    gsap.fromTo(beacon,
      {
        y: 0
      },
      {
        scrollTrigger: {
          trigger: processGrid,
          scrub: 1,
          start: "top 75%",
          // duration: processGrid.scrollHeight,
          // end: "+=" + processGrid.scrollHeight
          end: "bottom 66%"
        },
        y: "74vh"
      });
  }

  // Basic fade-ins
  var sections = document.querySelectorAll('div[id*="shopify-section-oystex"].shopify-section');
  var heroSection = document.querySelector('.oystex-icons')
  Array.prototype.forEach.call(sections, function (section) {
    var fadeItems = section.querySelectorAll('.gs-fade');
    console.log(fadeItems);

    gsap.set(fadeItems, {
      y: 60,
      autoAlpha: 0,
      duration: 0.75,
      ease: 'power2.out',
      overwrite: 'auto'
    });

    ScrollTrigger.create({
      trigger: section,
      start: "top 90%",
      end: "+=300",
      onEnter: function() {
        gsap.to(fadeItems, {
          y: 0,
          autoAlpha: 1,
          stagger: 0.15
        })
      }
    });
  });

  if (heroSection !== null) {
    gsap.set(heroSection.querySelectorAll('.icon-fade'), {
      y: 60,
      autoAlpha: 0,
      duration: 0.75,
      ease: 'power2.out',
      overwrite: 'auto'
    });

    ScrollTrigger.create({
      trigger: heroSection.querySelector('.icon-trigger'),
      start: "5% 90%",
      end: "+=300",
      onEnter: function() {
        gsap.to(heroSection.querySelectorAll('.icon-fade'), {
          y: 0,
          autoAlpha: 1,
          stagger: 0.15
        })
      }
    });
  }
};

window.addEventListener('load', function() {
  runScrolls();
})
